import { STORAGE_KEY } from "./Constant.js";
export const saveInLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
};

export const getFromLocalStorage = (key) => {
    return localStorage.getItem(key);
};

export const removeFromLocalStorage = (key) => {
    localStorage.removeItem(key);
};

export const clearSession = () => {
    // Clear session-related data
};

export const getUser = () => {
    let user = {
      candidateId: 0,
      candidateUniqueId: "",
      employeeUniqueId: "",
      firstname: "",
      lastName: "",
      employeeName:"",
      userActivationStatus: 0,
      userActivationStatusName: "",
      accessToken: "",
      accessExpiryTime: "",
      refreshToken: "",
      resetExpiryTime: "",
      mobileNumber: 0,
      emailId: "",
      loginType: 0,
      loginTypeName: "",
      roleId: -1,
      permissions: [],
      roleName: '',
      userId: "",
      sessionId: ''
    };
    const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
    if (data) {
      user = JSON.parse(data);
    }
    return user;
  };
  

  